<script lang="ts">
    import { assets as assetPath } from "$app/paths";
    import Image from "./Image.svelte";
    export let heading : string;
    export let description: string;
    export let url: string;
    export let image: any;

</script>
<a class="article-card" href={url}>
    <Image pngUrl={image} alt="Blog Card"/>
    <div class="article-card__content">
        <h3>{heading}</h3>
        <p>{description}</p>
    </div>
    <span class="article-card__readMore">Read more<img src={`${assetPath}/assets/blue-arrow.svg`} alt="Blue arrow indicating clickable link"/></span>
</a>

<style lang="postcss">

    @import '../../styles/_mixins.css';

    .article-card {
        max-width: 350px;
        background-color: var(--color_offerzen_midnight);
        padding:24px;
        border-radius: 10px;
        border: solid 1px rgba(#2f96f4, 0.25);
        transition: all .5s ease;
        text-decoration: none;

        @mixin screen-xxl {
            max-width:400px;
        }

        @mixin screen-md {
            max-width:100%;
            border-radius:12px;
            display:flex;
            flex-wrap:wrap;
        }

        @mixin screen-sm {
            max-width:320px;
        }


        & :global(img) {
            width:100%;
            border-radius:10px;
            margin-bottom:24px;

            @mixin screen-md {
                display:none;
            }

            @mixin screen-sm {
                display:block;
            }
        }

        & .article-card__content {

            height:230px;

            @mixin screen-lg {
                height:300px;
            }

            @mixin screen-md {
                height:100%;
            }

            @mixin screen-sm {
                height:430px;
                height:inherit;
            }

            & h3 {
                @mixin heading-h3;
                max-width: 300px;
                margin: 0 0 24px;
                color:var(--color_white);

                @mixin screen-md {
                    max-width:100%;
                    margin: 0 0 8px;
                }

                @mixin screen-sm { 
                    margin:0 0 16px;
                }
            }

            & p {
                @mixin paragraph;
                font-size:16px;
                max-width: 300px;
                overflow: hidden;
                color:var(--color_offerzen_lightblue_secondary);
                margin:0;

                @mixin screen-md {
                    max-width:100%;
                    margin:0 0 8px;
                }

                @mixin screen-sm{
                    margin:0 0 24px;
                }
            }

        }

        & .article-card__readMore {
            color: var(--color_offerzen_cerulean);
            text-decoration: none;
            display: flex;
            align-items: center;
            font-size:18px;
            font-weight:600;

            & img {
                height:15px;
                width:20px;
                margin:10px;
                transition: margin 1s;

                @mixin screen-md {
                    display:block;
                }
            }

            &:hover img{
                margin-left:15px;
            }

        }

        &:hover {
            transform: scale(1.03);
        }
    }

</style>